<template>
    <div class="body">
         <header class="header-section">
            <h1 class="main-title">供应商管理</h1>
            <h1 class="main-title">🔗携手合作，共创价值</h1>
            <div class="subtitle-wrapper">
                <span class="subtitle-badge">协作</span>
                <span class="subtitle-badge">信赖</span>
                <span class="subtitle-badge">精进</span>
            </div>
        </header>

        <section class="quote-card">
            <p class="p-highlight">建立稳固的合作关系，</p>
            <div class="p-content">
                <p>携手提升供应链韧性，</p>
            </div>
            <div class="p-content">
                <p>共创长期价值与成长。</p>
            </div>
        </section>

        <div class="wrapper">
            <div class="course-section">
                <!-- <h3 class="section-title">
                    <i class="icon-fire">🔥</i> 2025年11月热门课程
                </h3> -->
                <div class="course-grid">
                    <label v-for="(item, index) in proRecommend" :key="'hot-' + index" 
                           :class="['course-item', { 'is-active': selectedCourses.includes(item.Name) }]">
                        <input type="checkbox" :value="item.Name" v-model="selectedCourses" />
                        <span class="check-mark"></span>
                        <span class="course-name">{{ item.Name }}</span>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        ReportData: { type: Object, required: false },
        selected: { type: Array, default: () => [] }
    },
    data() {
        return {
            proRecommend:[],
            selectedCourses: []
        }
    },
    created() {
        if (this.ReportData) {
            this.proRecommend = JSON.parse(this.ReportData.proRecommend || '[]');
        }
    },
    watch: {
        selectedCourses: {
            deep: true,
            handler(newVal) {
                this.$emit('update:selected', newVal);
            }
        }
    },
    mounted() {
        this.selectedCourses = [...this.selected];
    }
}
</script>

<style scoped>
/* 变量定义 */
:root {
    --primary-green: #2d6a4f;
    --light-green: #d8f3dc;
    --accent-gold: #b78628;
    --text-main: #1b4332;
    --glass-bg: rgba(255, 255, 255, 0.85);
}

.body {
    background: 
        url("../../assets/26June/logo.png") right  top  no-repeat,
        url("../../assets/26June/bg.jpg")  no-repeat;
	background-size: 100% 100%,cover;
	width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden; /* 禁止全局滚动 */
    color: #333;
    box-sizing: border-box;
    padding: 20px 0;
}

/* 2. 头部：精致化 */
.header-section {
  padding-top: 6vh;
  text-align: center;
  margin-bottom: 15px;
}
.main-title {
  font-size: 24px;
  color: #03584e;
  margin: 0;
  font-weight: 800;
}
.subtitle-wrapper {
  margin-top: 8px;
  display: flex;
  gap: 10px;
  justify-content: center;
}
.subtitle-badge {
  font-size: 14px;
  background: #25726a;
  color: white;
  padding: 2px 10px;
  border-radius: 20px;
  opacity: 0.8;
}

/* 3. 引用卡片：减少空间占用 */
.quote-card {
  width: 88%;
  background: rgba(255, 255, 255, 0.7);
  border-left: 4px solid #03584e;
  padding: 12px 15px;
  margin-bottom: 20px;
  border-radius: 4px;
}
.p-highlight {
  font-weight: bold;
  color: #03584e;
  margin: 0 0 5px 0;
}
.p-content {
  font-size: 14px;
  color: #666;
  line-height: 1.4;
}
/* 课程列表区域 */
.wrapper {
    width: 90%;
    margin: 0 auto;
}

.course-section {
    background: var(--glass-bg);
    /* padding: 20px; */
    border-radius: 16px;
    /* margin-top: 20px; */
}

.section-title {
    font-size: 1.1rem;
    font-weight: bold;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
}

.section-desc {
    font-size: 0.85rem;
    color: #666;
    margin-bottom: 12px;
}

/* 交互式课程项 */
.course-grid {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.course-item {
    display: flex;
    align-items: center;
    padding: 14px 16px;
    background: #fff;
    border: 1.5px solid #e0e0e0;
    border-radius: 12px;
    transition: all 0.3s ease;
    cursor: pointer;
    position: relative;
}

.course-item input {
    position: absolute;
    opacity: 0;
}

.check-mark {
    width: 20px;
    height: 20px;
    border: 2px solid #ccc;
    border-radius: 50%;
    margin-right: 12px;
    position: relative;
    transition: all 0.3s;
    flex-shrink: 0;
}

.course-item:active {
    transform: scale(0.95);
}

.course-item.is-active {
    border-color: #008777;
    background: #f6f5e4;
    box-shadow: 0 4px 12px rgba(45, 106, 79, 0.1);
}

.course-item.is-active .check-mark {
    background: var(--primary-green);
    border-color: var(--primary-green);
}

.course-item.is-active .check-mark::after {
    content: '✓';
    color: #008777;
    position: absolute;
    left: 4px;
    top: -2px;
    font-size: 14px;
}

.course-name {
    font-size: 0.95rem;
    font-weight: 500;
}

.progress-style {
    border-left: 4px solid var(--accent-gold);
}

/* 交互增强：点击反馈 */
.course-item {
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1); /* 增加 Q 弹的贝塞尔曲线 */
}

.course-item:active {
    transform: scale(0.95);
}

.course-item.is-active {
   border-color: #008777;
    background: #f6f5e4;
    box-shadow: 0 4px 12px rgba(45, 106, 79, 0.1);
}

/* 打钩动画 */
.course-item.is-active .check-mark::after {
    animation: popIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes popIn {
    0% { transform: scale(0); }
    100% { transform: scale(1); }
}

/* PC 端适配 */
@media screen and (min-width: 786px) {
    .body {
        background: url("../../assets/26June/pcbg.png") no-repeat center;
        background-size: cover;
    }
    .quote-card, .wrapper {
        width: 600px;
    }
    .course-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 15px;
    }
}

.mt-4 { margin-top: 24px; }
</style>